export default __webpack_public_path__ + "static/media/fitness_white.d1bf2402.svg";